export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14977.a43c8cc6.jpg";